export const ES_TIP_TYPES = {
    SUCCESS: 'success',
    WARNING: 'warning',
    SUGGEST: 'suggest',
} as const;

export type ESTipType = (typeof ES_TIP_TYPES)[keyof typeof ES_TIP_TYPES];
